import React from 'react';
import { createRoot } from 'react-dom/client';
import '../pipeline/trade_program/trade_program.scss';
import TradeAttachments from '../trade_program/trade_attachments';

require.context('../pipeline/trade_program/try-on-wall', true);
require.context('../pipeline/trade_program/images', true);

const FORM_SELECTOR = 'form.trade-program-form';
const FOCUS_FORM_KEY = 'tradeProgramFocusForm';
const FIRST_NAME_ID = 'trade_program_request_firstname';
const HEADING_ID = 'application';

// When a guest signs in/up from the Trade Program page, the page reloads so the
// server can render the editable form. Carry the "focus the form" intent across
// that reload via sessionStorage, then act on it once the real form is present.
const armAfterAuthFocus = () => {
  window.after_auth = () => {
    try { sessionStorage.setItem(FOCUS_FORM_KEY, '1'); } catch (e) { /* ignore */ }
    window.location.reload();
  };
};

const focusFormIfRequested = () => {
  let requested = false;
  try { requested = sessionStorage.getItem(FOCUS_FORM_KEY) === '1'; } catch (e) { /* ignore */ }
  if (!requested) {
    return;
  }
  try { sessionStorage.removeItem(FOCUS_FORM_KEY); } catch (e) { /* ignore */ }

  const firstName = document.getElementById(FIRST_NAME_ID);
  if (!firstName || firstName.disabled) {
    return;
  }
  const heading = document.getElementById(HEADING_ID);
  (heading || firstName).scrollIntoView({ behavior: 'smooth', block: 'start' });
  firstName.focus({ preventScroll: true });
};

document.addEventListener('click', (event) => {
  if (event.target.closest('.trade-program-signin .signin-link, .trade-program-signin .signup-link')) {
    armAfterAuthFocus();
  }
});

const mountTradeAttachments = () => {
  const container = document.getElementById('trade_attachments');
  if (!container) {
    return;
  }
  const { sitekey } = container.dataset;
  createRoot(container).render(
    <TradeAttachments sitekey={ sitekey } formSelector={ FORM_SELECTOR } />
  );

  const form = document.querySelector(FORM_SELECTOR);
  if (form) {
    let tokenReady = false;
    form.addEventListener('submit', (event) => {
      if (tokenReady) {
        tokenReady = false;
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      // grecaptcha may be blocked or not finished loading; guard so a failed
      // token mint doesn't leave the (already prevented) submit dead with no
      // feedback — surface it and let the user retry.
      const execute = window.grecaptcha
        && window.grecaptcha.enterprise
        && window.grecaptcha.enterprise.execute;
      if (!execute) {
        alert('Verification is still loading. Please try again in a moment.'); // eslint-disable-line no-alert
        return;
      }
      execute(sitekey, { action: 'trade' }).then((token) => {
        document.getElementById('tp-captcha').value = token;
        tokenReady = true;
        // Dispatch a native, bubbling submit so rails-ujs' document-level remote
        // handler runs (adds the X-CSRF-Token header). jQuery's .trigger('submit')
        // would instead invoke the native full-page submit, which rails-ujs never
        // sees, so the request arrives without a CSRF token and is rejected.
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }).catch(() => {
        alert('Verification failed. Please try again.'); // eslint-disable-line no-alert
      });
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  mountTradeAttachments();
  focusFormIfRequested();
});

window.asyncLoadScript = (scriptURL, condition) => new Promise((resolve, reject) => {
  if (condition) {
    resolve();
    return;
  }
  const script = document.createElement('script');
  script.src = scriptURL;
  script.async = true;
  script.onload = () => resolve();
  script.onerror = (error) => reject(error);
  document.body.appendChild(script);
});
